/**
 * Core templates
 */

const templates = {
  layout: {
    top_menu_item:
      '<a title="<%= label %>" class="<% if (children.length) { %>dropdown-toggle<% } else { %>no-children<% } %>"<% if (enabled) { %> href="<% if (url) { %><%= url %><% } else { %>#<%= path %><% } %>"<% } %><% if (children.length) { %> data-toggle="dropdown" id="dd-<%= name %>"<% } %>><span class="icon fa fa-fw<% if (icon) { %> fa-<%= icon %><% } %>"></span><span class="name"><%= label %></span><% if (children.length) { %><span class="fa fa-fw fa-caret-down"></span><% } %></a><% if (children.length) { %><ul class="dropdown-menu nav-second-level" aria-labelledby="dd-<%= name %>"></ul><% } %>',
    side_menu_item: `
			<% if (enabled) { %>
				<a href="#<%= path %>" title="<%= label %>">
					<% if (children.length) { %>
						<span class="fa fa-fw fa-caret-down"></span>
					<% } %>
					<%= label %>
				</a>
			<% } else { %>
				<a data-toggle="tooltip" title="The link to <%= label %> is disabled. Please contact your Program Manager.">
					<% if (children.length) { %>
						<span class="fa fa-fw fa-caret-down"></span>
					<% } %>
					<%= label %>
				</a>
			<% } %>
			<% if (children.length) { %>
				<ul class="nav"></ul>
			<% } %>
		`,
    report_container:
      '<!-- legend container --><div class="row report-legend"></div><!-- report menu container --><div class="row report-menu"><div class="report-filters col-xs-4"><div class="btn-group"><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-filter"></i>&nbsp;Filters&nbsp;<span class="caret"></span></button><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-list"></i>&nbsp;Group By&nbsp;<span class="caret"></span></button></div></div><div class="report-actions col-xs-8"><div class="btn-group pull-right"><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-gear"></i></button><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-download"></i></button></div></div></div><!-- table container --><div class="table-container col-xs-12"></div>',
    report_container_main_screen:
      '<!-- legend container --><div class="row report-legend"></div><!-- table container --><div class="row"><div class="table-container col-xs-12"></div></div>',
    generic_tabbed_view:
      '<!-- nav tabs --><ul class="nav nav-tabs" role="tablist"><% _.each(tabs, function(tab) { %><li role="presentation"<% if (tab.active) { %> class="active"<% } %>><a href="#tab-<%= tab.id %>" aria-controls="tab-<%= tab.id %>" role="tab" data-toggle="tab"><%= tab.label %></a></li><% }) %></ul><!-- content panes --><div class="tab-content horizontal tabbed"><% _.each(tabs, function(tab) { %><div role="tabpanel" class="tab-pane fade in<% if (tab.active) { %> active<% } %>" id="tab-<%= tab.id %>"><!-- <%= tab.label %> content here --><div class="loading-indicator"></div></div><% }) %></div>',
    drilldown_tabbed_view:
      '<!-- nav tabs --><ul class="nav nav-tabs" role="tablist"><% _.each(menu, function(tab) { %><li role="presentation"<% if (tab.active) { %> class="active"<% } %>><a href="#tab-<%= tab.name %>" aria-controls="tab-<%= tab.name %>" role="tab" data-route="<%= tab.name %>" data-toggle="tab" data-event-category="Drilldown Tab" data-event-action="Open" data-event-label="<%= tab.label %>"><%= tab.label %></a></li><% }) %></ul><!-- content panes --><div class="tab-content horizontal tabbed"><% _.each(menu, function(tab) { %><div role="tabpanel" class="tab-pane fade in<% if (tab.active) { %> active<% } %>" id="tab-<%= tab.name %>"><div class="loading-indicator"></div></div><% }) %></div>',
    drilldown_stacked_view:
      '<!-- nav pills --><ul class="nav nav-pills nav-stacked col-xs-4" role="tablist"><% _.each(menu, function(tab) { %><li role="presentation"<% if (tab.active) { %> class="active"<% } %>><a href="#tab-<%= tab.name %>" aria-controls="tab-<%= tab.name %>" role="tab" data-route="<%= tab.name %>" data-toggle="tab" data-event-category="Drilldown Tab" data-event-action="Open" data-event-label="<%= tab.label %>"><%= tab.label %></a></li><% }) %></ul><!-- content panes --><div class="tab-content stacked col-xs-8"><% _.each(menu, function(tab) { %><div role="tabpanel" class="tab-pane fade in<% if (tab.active) { %> active<% } %>" id="tab-<%= tab.name %>"><div class="loading-indicator"></div></div><% }) %></div>',
    generic_button:
      '<% if (icon) { %><i class="fa fa-fw fa-<%= icon %>" aria-hidden="true"></i><% } %><% if (icon && label) { %>&nbsp;<% } %><% if (label) { %><%= label %><% } %>',
    active_filter:
      '<i class="fa fa-fw fa-<%= icon %>"></i>&nbsp;<strong><%= name %>:</strong>&nbsp;<%= value %>',
    dropdown_button:
      '<button type="button" aria-label="Options" class="btn btn-sm btn-standard dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><% if (icon) { %><i class="fa fa-fw fa-<%= icon %>"></i>&nbsp;<% } %><% if (label) { %><%= label %>&nbsp;<% } %><span class="caret"></span></button><ul class="dropdown-menu"><!-- dropdown options --><li role="separator" class="divider"></li><li class="options-buttons pull-right"><button type="button" class="btn btn-link reset" aria-label="Click to remove all your filters and group-by selections" title="Click to remove all your filters and group-by selections at once">Reset</button><button type="submit" class="btn btn-standard"><i class="fa fa-fw fa-check"></i>&nbsp;Apply</button></li></ul>',
    single_record_view:
      '<% _.forEach(singleRecord, function(item){ %><div class="form-group"><label class="col-xs-2 control-label"><%= item.label %>:</label><div class="col-xs-10"><p class="form-control-static"><%= item.value %></p></div></div><% }); %>',
    missing_content:
      '<div class="row"><div class="title col-xs-12"><h3 class="page-header"><small>Error</small><br>Content Not Found</h3></div></div>',
    meta_and_report:
      '<div class="meta"><!-- meta goes here --></div><div class="report"><!-- report goes here --></div>',
  },
  masthead: {
    dropdown:
      '<div class="dropdown-toggle" <% if (children.length) { %>data-toggle="dropdown" <% } %>role="button" aria-expanded="false"><%= label %><% if (children.length) { %>&nbsp;<span class="caret"></span><% } %></div><nav class="dropdown-menu nav-item-list<% if (className) { %> <%= className %><% } %>"></nav>',
    dropdown_with_icon:
      '<div class="dropdown-toggle" <% if (children.length) { %>data-toggle="dropdown" <% } %>role="button" aria-expanded="false"> <% if (icon) { %><span class="fa fa-fw fa-<%= icon %>"></span>&nbsp;&nbsp;<% } %><%= label %><% if (children.length) { %>&nbsp;<span class="caret"></span><% } %></div><nav class="dropdown-menu nav-item-list"></nav>',
    dropdown_link:
      '<% if (divider) { %><div class="dropdown-divider"></div><% } %><a href="<% if (url) { %><%= url %><% } else { %>#<%= path %><% } %>"<% if (external) { %> target="_blank" rel="noopener"<% } %> class="dropdown-link<% if (current) { %> current<% } %>"><%= label %><% if (external) { %>&nbsp;<span class="fa fa-fw fa-external-link"></span><% } %></a>',
    // item: "<a role=\"button\" title=\"<%= label %>\" href=\"<% if (url) { %><%= url %><% } else { %>#<%= path %><% } %>\"> <% if (icon) { %><span class=\"fa fa-fw fa-<%= icon %>\"></span>&nbsp;&nbsp;<% } %><%= label %> </a>"
    avatar:
      '<div class="dropdown-toggle user-icon" data-toggle="dropdown" role="button" aria-expanded="false"></div><nav class="dropdown-menu nav-item-list user-dropdown"></nav>',
    avatar_dropdown:
      '<div class="user-dropdown-header"></div><div class="user-dropdown-links"></div>',
    avatar_dropdown_header:
      '<div class="user-dropdown-avatar"></div><div class="user-dropdown-title"></div>',
    avatar_dropdown_title:
      '<div><%= fullName %></div><div class="user-dropdown-email<% if (!email) { %> text-muted<% } %>"><% if (email) { %><%= email %><% } else { %>Email address not set<% } %></div>',
  },
  view_header: {
    actions_placeholder:
      '<div class="flex filters"><div class="action-wrapper dropdown"><button disabled class="btn btn-sm btn-standard dropdown-toggle" data-toggle="dropdown"><i class="fa fa-fw fa-filter" aria-hidden="true"></i>&nbsp;Filters&nbsp;<span class="caret"></span></button></div><div class="action-wrapper"><button disabled class="btn btn-sm btn-standard"><i class="fa fa-fw fa-list" aria-hidden="true"></i>&nbsp;Group By&nbsp;<span class="caret"></span></button></div></div><div class="flex actions"><div class="action-wrapper btn-group"><button disabled title="Customize View" class="btn btn-sm btn-standard"><i class="fa fa-fw fa-gear" aria-hidden="true"></i></button> <button disabled title="Export" class="btn btn-sm btn-standard"><i class="fa fa-fw fa-download" aria-hidden="true"></i></button></div></div>',
    actions_placeholder_group:
      '<div class="flex filters btn-group"><form action="#" class="btn-group"><div class="btn-group"><button disabled type="button" aria-label="Filters" class="btn btn-sm btn-standard"><i class="fa fa-fw fa-filter"></i>&nbsp;Filters&nbsp;<span class="caret"></span></button></div><div class="btn-group"><button disabled type="button" aria-label="Group By" class="btn btn-sm btn-standard"><i class="fa fa-fw fa-list"></i>&nbsp;Group By&nbsp;<span class="caret"></span></button></div></form></div><div class="flex actions"><div class="action-wrapper btn-group"><button disabled title="Customize View" class="btn btn-sm btn-standard"><i class="fa fa-fw fa-gear" aria-hidden="true"></i></button> <button disabled title="Export" class="btn btn-sm btn-standard"><i class="fa fa-fw fa-download" aria-hidden="true"></i></button></div></div>',
  },
  generic: {
    page_layout: `
			<main role="main">
				<div class="view-header">
					<div class="view-header-breadcrumbs"></div>
					<div class="view-header-actions"></div>
				</div>
				<div id="content"></div>
			</main>
		`,
    form_layout: `
			<form class="row">
				<div class="col-xs-12 form-instructions"></div>
				<div class="col-xs-12 form-fields"></div>
				<div class="col-xs-12 form-buttons text-right"></div>
			</form>
		`,
    table_header:
      "<thead><tr><% _.each(columns, function(column) { %><th><%= column %></th><% }); %></tr></thead>",
    linked_cell: `
			<a class="<%= className %>"
				href="#<%= url.endpoint %>"
				data-url="<%= RVC.Utils.encodeData(url.endpoint) %>"
				data-params="<%= RVC.Utils.encodeData(JSON.stringify(url.data)) %>"
				data-type="<%= url.type %>"
				<% if (returnRoute) { %>
					data-return-route="<%= returnRoute %>"
					data-return-route-refresh="<%= returnRouteRefresh %>"
				<% } %>
				data-event-category="Drilldown"
				data-event-action="Open"
				data-event-label="Report Link"
			>
				<%= value %>
			</a>
		`,
    no_results: '<div class="text-muted">No results found.</div>',
    alert:
      '<% if (icon) { %><i class="fa fa-fw fa-<%= icon %> fa-lg"></i>&nbsp;&nbsp;<% } %><% if (!autoDismiss) { %><button type="button" aria-label="Close" class="close" aria-label="Close" data-event-category="Alert" data-event-action="Close"><i class="fa fa-fw fa-times-circle" aria-hidden="true"></i></button><% } %><%= message %>',
    tooltip:
      '<abbr href="#" data-toggle="tooltip" data-content="<%= tooltip %>"><%= value %></abbr>',
    popover:
      '<abbr href="#" data-toggle="popover" data-content="<ul><% _.forEach(tooltip, function(item) { %><li><strong><%= RVC.Utils.htmlEscape(item.key) %></strong>: <%= RVC.Utils.htmlEscape(item.value) %></li><% }) %></ul>"><%= value %></abbr>',
    breadcrumb: `
			<% if (url) { %>
				<a href="<%= url %>" class="_breadcrumb-group">
					<div class="_breadcrumb-title"><%= title %></div>
					<div class="_breadcrumb-item-description"><%= subtitle %></div>
				</a>
			<% } else { %>
				<div class="_breadcrumb-group">
					<div class="_breadcrumb-title"><%= title %></div>
					<div class="_breadcrumb-item-description"><%= subtitle %></div>
				</div>
			<% } %>
		`,
  },
  environment_selector: {
    layout: `
			<h2>Select an Environment</h2>
			<p class="lead text-muted">You have access to multiple environments, please choose one:</p>
			<div class="environment-list"></div>
			<div class="pull-right">
				<a role="button" class="btn btn-link" href="./">Cancel</a>
				<button disabled type="button" aria-label="Save and Reload" class="btn btn-lg btn-emphasized submit">Save &amp; Reload</button>
			</div>
		`,
    item: `
			<%= description %>
			<% if (checked) { %>&nbsp;&nbsp;<i class="fa fa-fw fa-lg fa-check"></i><% } %>
		`,
  },
  admin: {
    account: `
			<fieldset>
				<legend><% if (id) { %><%= username %><% } else { %>New User<% } %></legend>
				<div class="form-group">
					<label class="col-xs-3 control-label">Username:</label>
					<div class="col-xs-9">
						<input required type="text" autocomplete="off" class="form-control" name="username" placeholder="Username" value="<%= username %>">
					</div>
				</div>
				<div class="form-group">
					<label class="col-xs-3 control-label">CIAM User ID:</label>
					<div class="col-xs-9">
						<input required type="text" autocomplete="off" class="form-control" name="ciamUserId" placeholder="CIAM UUID" value="<%= ciamUserId %>">
					</div>
				</div>
				<div class="form-group">
					<label class="col-xs-3 control-label">First Name:</label>
					<div class="col-xs-9">
						<input required type="text" autocomplete="off" class="form-control" name="firstName" placeholder="First Name" value="<%= firstName %>">
					</div>
				</div>
				<div class="form-group">
					<label class="col-xs-3 control-label">Last Name:</label>
					<div class="col-xs-9">
						<input required type="text" autocomplete="off" class="form-control" name="lastName" placeholder="Last Name" value="<%= lastName %>">
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-offset-3 col-xs-9">
						<div class="checkbox">
							<label><input type="checkbox" name="enabled" value="1" <% if (enabled) { %> checked <% } %>> Enabled</label>
						</div>
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-offset-3 col-xs-9">
						<div class="checkbox">
							<label><input type="checkbox" name="visible" value="1" <% if (visible) { %> checked <% } %>> Visible</label>
						</div>
					</div>
				</div>
			</fieldset>
			<!-- internal roles -->
			<fieldset>
				<legend>Internal Roles</legend>
				<% _.forEach(roles, function(role){ if (role.internalOnly) { %>
					<div class="form-group">
						<div class="col-xs-offset-3 col-xs-9">
							<div class="checkbox">
								<label><input type="checkbox" name="roles" value="<%= role.id %>" <% if (role.checked) { %> checked <% } %>> <%= role.name %> </label>
							</div>
						</div>
					</div>
				<% }}) %>
			</fieldset>
			<!-- client roles -->
			<fieldset>
				<legend>Client Roles</legend>
				<% _.forEach(roles, function(role){ if (!role.internalOnly) { %>
					<div class="form-group">
						<div class="col-xs-offset-3 col-xs-9">
							<div class="checkbox">
								<label><input type="checkbox" name="roles" value="<%= role.id %>" <% if (role.checked) { %> checked <% } %>> <%= role.name %> </label>
							</div>
						</div>
					</div>
				<% }}) %>
			</fieldset>
		`,
  },
  tools: {
    healthcheck_config: `
			<div class="form-group">
				<div class="checkbox">
					<label>
						<input type="checkbox"
							name="enabled"
							<% if (enabled) { %>checked<% } %>
						>
						<strong>&nbsp;Enable Healthcheck</strong>
					</label>
				</div>
			</div>
			<div class="form-group">
				<label class="control-label">Interval:</label>
				<input required class="form-control"
					type="number"
					min="<%= intervalMin %>"
					max="<%= intervalMax %>"
					name="interval"
					value="<%= interval %>"
				>
			</div>
		`,
  },
  report: {
    title: "<small><%= title %></small><br/><%= subtitle %>",
    footer:
      '<tr><td colspan="<%= data.totalColumns %>">Showing <%= RVC.Utils.numberFormatter(data.firstRow) %> to <%= RVC.Utils.numberFormatter(data.lastRow) %> of <%= RVC.Utils.numberFormatter(data.totalRows) %> entries</td></tr>',
    customize_report_instructions:
      '<p class="lead text-muted">Select the columns you wish to see in your report. To order them, drag and drop them into place.</p><% if (_created) { %><p class="small text-muted">Last updated <abbr data-toggle="tooltip" data-placement="bottom" data-container="body" title="<%= RVC.Utils.dateFormatter(_created,"LLLL") %>" data-utime="<%= _created %>"><%= RVC.Utils.relativeDateFormatter(_created) %></abbr>.</p><% } %>',
    customize_report_column:
      '<div class="checkbox"><label><input type="checkbox" name="<%= elementId %>" <% if (checked) { %> checked <% } %>>&nbsp;<%= nameOriginal %></label></div>',
    debug_sql:
      '<span class="badge" title="Execution time"><%= executionTime %></span><h4><%= name %></h4><code><%= statement %></code>',
    debug_stacktrace:
      "<h4><%= description %></h4><pre><%= additionalInfo %></pre>",
    role_selector:
      '<div class="checkbox"><label><input type="checkbox" name="<%= id %>"<% if (checked) { %> checked<% } %>>&nbsp<%= name %></label></div>',
  },
  group_by: {
    options:
      '<% _.each(data, function(item) { %><div class="checkbox"><label><input type="checkbox" <% if (item.checked) { %>checked<% } %> name="<%= formParamName %>" value="<%= item.value %>"> <%= item.label %></label></div><% }); %>',
  },
  chart_reviews: {
    member_search:
      '<div class="row"><div class="col-sm-3"><div class="card"><p class="lead text-muted">Enter your search criteria below and select a member from the list on the right.</p><div><input type="text" autocomplete="off" id="memberNumber" name="memberNumber" class="form-control" placeholder="Member Number" value=""></div><div><input type="text" autocomplete="off" id="firstName" name="firstName" class="form-control" placeholder="First Name" value=""></div><div><input type="text" autocomplete="off" id="lastName" name="lastName" class="form-control" placeholder="Last Name" value=""></div><div class="text-right"><button type="reset" class="btn btn-link">Undo</button>&nbsp;<button type="submit" class="btn btn-standard">Search</button></div></div></div><div class="col-sm-9"><!-- report menu container --><div class="row report-menu"><div class="report-filters col-sm-4"><div class="btn-group"><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-filter"></i>&nbsp;Filters&nbsp;<span class="caret"></span></button><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-list"></i>&nbsp;Group By&nbsp;<span class="caret"></span></button></div></div><div class="report-actions col-sm-8"><div class="btn-group pull-right"><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-gear"></i></button><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-download"></i></button></div></div></div><!-- table container --><div class="row"><div class="table-container col-lg-12"></div></div></div></div>',
    provider_search:
      '<div class="row"><div class="col-sm-3"><div class="card"><p class="lead text-muted">Enter your search criteria below and select a provider from the list on the right.</p><div><input type="text" autocomplete="off" id="providerNumber" name="providerNumber" class="form-control" placeholder="Provider Number" value=""></div><div><input type="text" autocomplete="off" id="firstName" name="firstName" class="form-control" placeholder="First Name" value=""></div><div><input type="text" autocomplete="off" id="lastName" name="lastName" class="form-control" placeholder="Last Name" value=""></div><div class="text-right"><button type="reset" class="btn btn-link">Undo</button>&nbsp;<button type="submit" class="btn btn-standard">Search</button></div></div></div><div class="col-sm-9"><!-- report menu container --><div class="row report-menu"><div class="report-filters col-sm-4"><div class="btn-group"><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-filter"></i>&nbsp;Filters&nbsp;<span class="caret"></span></button><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-list"></i>&nbsp;Group By&nbsp;<span class="caret"></span></button></div></div><div class="report-actions col-sm-8"><div class="btn-group pull-right"><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-gear"></i></button><button class="btn btn-sm btn-standard disabled"><i class="fa fa-fw fa-download"></i></button></div></div></div><!-- table container --><div class="row"><div class="table-container col-lg-12"></div></div></div></div>',
    project_create: `
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="managers">* Project Name:</label>
						<div class="input-group">
							<input autocomplete="off" id="name" name="name" class="form-control" placeholder="Enter a project name">
							<span class="input-group-addon"><i class="fa fa-lg fa-pencil" aria-hidden="true"></i></span>
						</div>
						<span class="help-block small">&nbsp;</span>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="statuses">Status:</label>
						<select id="statuses" name="statusValue" class="form-control chosen-select"><% _.forEach(statuses, function(status){ %>
							<option <% if (status.checked) { %> selected <% } %> value="<%= status.key %>"><%= status.value %></option>
						<% }); %></select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="managers">Managers:</label>
						<select multiple id="managers" name="managers" class="form-control chosen-select"><% _.forEach(managers, function(user){ %>
							<option value="<%= user.id %>"><%= user.firstName %> <%= user.lastName %></option>
						<% }); %></select>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="notes">Notes:</label>
						<input autocomplete="off" id="notes" name="notes" class="form-control" placeholder="Optional project notes">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="reviewers">Reviewers:</label>
						<select multiple id="reviewers" name="reviewers" class="form-control chosen-select"><% _.forEach(reviewers, function(user){ %>
							<option value="<%= user.id %>">
								<%= user.firstName %> <%= user.lastName %> (<%= user.openChartsAssigned %>)
							</option>
						<% }); %></select>
					</div>
				</div>
				<div class="col-sm-6">
				</div>
			</div>
		`,
    project_edit: `
			<input type="hidden" name="id" value="<%= id %>">
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="managers">* Project Name:</label>
						<div class="input-group">
							<input autocomplete="off" id="name" name="name" class="form-control" placeholder="Enter a project name" value="<%= name %>">
							<span class="input-group-addon"><i class="fa fa-lg fa-pencil" aria-hidden="true"></i></span>
						</div>
						<span class="help-block small">&nbsp;</span>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="statuses">Status:</label>
						<select id="statuses" name="statusValue" class="form-control chosen-select"><% _.forEach(statuses, function(status){ %>
							<option <% if (status.checked) { %> selected <% } %> value="<%= status.key %>"><%= status.value %></option>
						<% }); %></select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="managers">Managers:</label>
						<select multiple id="managers" name="managers" class="form-control chosen-select"><% _.forEach(managers, function(user){ %>
							<option value="<%= user.id %>" <% if (user.checked) { %> selected <% } %>><%= user.firstName %> <%= user.lastName %></option>
						<% }); %></select>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="notes">Notes:</label>
						<input autocomplete="off" id="notes" name="notes" class="form-control" placeholder="Optional project notes"
							value="<% if (notes) { %><%= RVC.Utils.htmlUnescape(notes) %><% } %>"
						>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="reviewers">Reviewers:</label>
						<select multiple id="reviewers" name="reviewers" class="form-control chosen-select"><% _.forEach(reviewers, function(user){ %>
							<option value="<%= user.id %>"
								<% if (user.checked) { %> selected <% } %>
							>
								<%= user.firstName %> <%= user.lastName %> (<%= user.openChartsAssigned %>)
							</option>
						<% }); %></select>
					</div>
				</div>
			</div>
		`,
    chart_create_chart: `
			<fieldset>
				<div class="row card-group">
					<div class="col-sm-6">
						<div class="form-group card">
							<div class="card-header">Member</div>
							<div class="card-body">
								<% if (selectedMember) { %>
									<input type="hidden" name="member" value="<%= selectedMember.id %>">
									<p># <%= selectedMember.memberNumber %></p>
									<p>
										<strong><%= selectedMember.firstName %> <%= selectedMember.lastName %></strong><br>
										<%= selectedMember.city %>,&nbsp;<%= selectedMember.state %>&nbsp;&nbsp;<%= selectedMember.zip %>
									</p>
									<p>
										<strong>DOB:</strong>&nbsp;<%= RVC.Utils.dateFormatter(selectedMember.dateOfBirth) %>
									</p>
									<button type="button" aria-label="Select a Member" class="btn btn-standard btn-sm select-member">
										<i class="fa fa-fw fa-search"></i>&nbsp;Change Member
									</button>
								<% } else { %>
									<button type="button" aria-label="Select a Member" class="btn btn-emphasized select-member">
										<i class="fa fa-fw fa-search"></i>&nbsp;Select a Member
									</button>
								<% } %>
							</div>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group card">
							<div class="card-header">Provider</div>
							<div class="card-body">
								<% if (selectedProvider) { %>
									<input type="hidden" name="provider" value="<%= selectedProvider.id %>">
									<p># <%= selectedProvider.providerNumber %></p>
									<p>
										<strong><%= selectedProvider.firstName %> <%= selectedProvider.lastName %></strong><br>
										<%= selectedProvider.city %>,&nbsp;<%= selectedProvider.state %>&nbsp;&nbsp;<%= selectedProvider.zip %>
									</p>
									<p>&nbsp;</p>
									<button type="button" aria-label="Select a Provider" class="btn btn-standard btn-sm select-provider">
										<i class="fa fa-fw fa-search"></i>&nbsp;Change Provider
									</button>
								<% } else { %>
									<button type="button" aria-label="Select a Provider" class="btn btn-emphasized select-provider">
										<i class="fa fa-fw fa-search"></i>&nbsp;Select a Provider
									</button>
								<% } %>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group card">
					<div class="row">
						<div class="col-sm-3">
							<div class="form-group">
								<label class="control-label" for="projectId">* Project:</label>
								<select class="form-control chosen-select" id="projectId" name="projectId"><option value=""></option>
									<% _.forEach(projectIdList, function(option){ %>
										<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
									<% }); %>
								</select>
							</div>
						</div>
						<div class="col-sm-3">
							<div class="form-group">
								<label class="control-label" for="retrievalStatus">* Retrieval Status:</label>
								<select class="form-control chosen-select" id="retrievalStatus" name="retrievalStatus"><option value=""></option>
									<% _.forEach(retrievalStatusList, function(option){ %>
										<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
									<% }); %>
								</select>
							</div>
						</div>
						<div class="col-sm-3">
							<div class="form-group">
								<label class="control-label" for="receivedDate">Received Date:</label>
								<input type="date" id="receivedDate" name="receivedDate" autocomplete="off"
									class="form-control rvc-datepicker"
									placeholder="mm/dd/yyyy"
									<% if (receivedDate) { %>data-value="<%= receivedDate %>"<% } %>
								>
							</div>
						</div>
						<div class="col-sm-3">
							<div class="form-group">
								<label class="control-label" for="providerGroupNumber">Provider Group:</label>
								<input id="providerGroupNumber" name="providerGroupNumber" autocomplete="off" class="form-control" value="<%= providerGroupNumber %>">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-3">
							<div class="form-group">
								<label class="control-label" for="customerRefNumber">Customer Reference Number:</label>
								<input id="customerRefNumber" name="customerRefNumber" autocomplete="off" class="form-control" value="<%= customerRefNumber %>">
							</div>
						</div>
						<div class="col-sm-3">
							<div class="form-group">
								<label
									<% if (retrievalStatus !== "NOT_AVAILABLE") { %>class="text-muted"<% } %>
									for="retrievalStatusNAReason"><% if (retrievalStatus === "NOT_AVAILABLE") { %>* <% } %>Not Available Reason:</label>
								<br>
								<select
									<% if (retrievalStatus !== "NOT_AVAILABLE") { %>disabled<% } %>
									class="form-control chosen-select" name="retrievalStatusNAReason" id="retrievalStatusNAReason"><option value=""></option>
									<% _.forEach(retrievalStatusNAReasonList, function(option){ %>
										<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
									<% }); %>
								</select>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="form-group">
								<label class="control-label" for="reviewers">Reviewers:</label>
								<select multiple id="reviewers" name="reviewers" class="form-control chosen-select">
									<% _.forEach(reviewersList, function(user){ %>
										<option value="<%= user.id %>"
											<% if (user.checked) { %> selected <% } %>
										>
											<%= user.firstName %> <%= user.lastName %> (<%= user.openChartsAssigned %>)
										</option>
									<% }); %>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<div class="form-group">
								<label class="control-label" for="note">Chart Note:</label>
								<input id="note" name="note" autocomplete="off" class="form-control" value="<%= note %>">
							</div>
						</div>
						<div class="col-sm-6"></div>
					</div>
					<div class="row">
						<div class="col-sm-6"></div>
						<div class="col-sm-6 text-right">
							<button type="reset" class="btn btn-link">Undo</button>
							<button type="submit" class="btn btn-standard save-exit">Save &amp; Exit</button>
							<button type="button" aria-label="Save and View Chart" class="btn btn-emphasized save-open">Save &amp; View Chart</button>
						</div>
					</div>
				</div>
			</fieldset>
		`,
    chart_edit_meta:
      '<div class="row"><div class="col-sm-4 meta-review-number"><!-- review number --></div><div class="col-sm-8 text-right meta-project-name"><!-- project name --></div></div><div class="row card-group"><div class="col-sm-3 meta-member"><!-- member --></div><div class="col-sm-3 meta-eligibility"><!-- eligibility --></div><div class="col-sm-3 meta-categories"><!-- hcc member categories --></div><div class="col-sm-3 meta-provider"><!-- provider --></div></div>',
    chart_edit_meta_no_data: '<p class="text-muted">Data is not available</p>',
    chart_edit_meta_review:
      "<h4>Review Number: <strong><%= reviewNumber %></strong></h4>",
    chart_edit_meta_project_name:
      "<h4>Project: <strong><%= projectName %></strong></h4>",
    chart_edit_meta_member:
      '<div class="card-header">Member</div><div class="card-body"> <% if (selectedMember) { %> <p># <%= selectedMember.memberNumber %></p><p><strong><%= selectedMember.firstName %>&nbsp;<%= selectedMember.lastName %></strong><br><%= selectedMember.city %>,&nbsp;<%= selectedMember.state %>&nbsp;&nbsp;<%= selectedMember.zip %></p><p><strong>DOB:</strong>&nbsp;<%= RVC.Utils.dateFormatter(selectedMember.dateOfBirth) %></p> <% } %> </div>',
    chart_edit_meta_provider:
      '<div class="card-header">Provider</div><div class="card-body"> <% if (selectedProvider) { %> <p># <%= selectedProvider.providerNumber %></p><p><strong><%= selectedProvider.firstName %>&nbsp;<%= selectedProvider.lastName %></strong><br><%= selectedProvider.city %>,&nbsp;<%= selectedProvider.state %>&nbsp;&nbsp;<%= selectedProvider.zip %></p> <% } %> </div>',
    chart_edit_meta_eligibility_list:
      '<div class="card-header">Member Eligibility</div><div class="card-body eligibility-list"><!-- list here --></div>',
    chart_edit_meta_eligibility_list_item:
      '<div class="list-group-item-heading"><strong><%= commercialPlanId %></strong></div><div class="list-group-item-text"><%= RVC.Utils.dateFormatter(startDate) %> - <%= RVC.Utils.dateFormatter(endDate) %></div>',
    chart_edit_meta_categories_list:
      '<div class="card-header">Categories<% if (asOfMonth) { %> as of <%= asOfMonth %><% } %></div><div class="card-body member-categories-list"><!-- list here --></div>',
    chart_edit_meta_categories_list_item:
      '<div class="list-group-item-heading"><strong><%= type %>:</strong></div><div class="list-group-item-text"><abbr data-toggle="popover" data-content="<ul><% _.forEach(tooltip, function(item) { %><li><strong><%= RVC.Utils.htmlEscape(item.key) %></strong>: <%= RVC.Utils.htmlEscape(item.value) %></li><% }) %></ul>"><%= value %></abbr></div>',
    chart_edit_chart_layout: `
			<div class="chart-review-meta"></div>
			<div class="chart-review-form card">
				<div class="card-header">Chart Details</div>
				<div class="body"></div>
			</div>
			<div class="chart-review-notes card">
				<div class="card-header">Chart Notes</div>
				<div class="card-body"></div>
			</div>
		`,
    chart_edit_chart_form: `
			<% if (id) { %><input type="hidden" name="id" value="<%= id %>"><% } %>
			<% if (selectedMember) { %><input type="hidden" name="member" value="<%= selectedMember.id %>"><% } %>
			<% if (selectedProvider) { %><input type="hidden" name="provider" value="<%= selectedProvider.id %>"><% } %>
			<% if (providerGroupId) { %><input type="hidden" name="providerGroupId" value="<%= providerGroupId %>"><% } %>
			<% if (providerGroupName) { %><input type="hidden" name="providerGroupName" value="<%= providerGroupName %>"><% } %>
			<div class="row">
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="projectId">* Project:</label>
						<select class="form-control chosen-select" id="projectId" name="projectId"><option value=""></option>
							<% _.forEach(projectIdList, function(option){ %>
								<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
							<% }); %>
						</select>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="retrievalStatus">* Retrieval Status:</label>
						<select class="form-control chosen-select" id="retrievalStatus" name="retrievalStatus"><option value=""></option>
							<% _.forEach(retrievalStatusList, function(option){ %>
								<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
							<% }); %>
						</select>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="receivedDate">Received Date:</label>
						<input type="date" id="receivedDate" name="receivedDate" autocomplete="off"
							class="form-control rvc-datepicker"
							placeholder="mm/dd/yyyy"
							<% if (receivedDate) { %>data-value="<%= receivedDate %>"<% } %>
							<% if (diagMinDate) { %>data-min="<%= diagMinDate %>"<% } %>
						>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="col-sm-4">
						<div class="form-group">
							<label class="control-label">Reviewed Date:</label>
							<% if (reviewedDate) { %>
								<p class="form-control-static"><%= reviewedDate %></p>
							<% } else { %>
								<p class="form-control-static text-muted">N/A</p>
							<% } %>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<label class="control-label">Closed Date:</label>
							<% if (closedDate) { %>
								<p class="form-control-static"><%= closedDate %></p>
							<% } else { %>
								<p class="form-control-static text-muted">N/A</p>
							<% } %>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
							<label class="control-label">Chase List Rank:</label>
							<% if (chaseListRank) { %>
								<p class="form-control-static"><%= chaseListRank %></p>
							<% } else { %>
								<p class="form-control-static text-muted">N/A</p>
							<% } %>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="customerLocation">Customer Location:</label>
						<input id="customerLocation" name="customerLocation" autocomplete="off" class="form-control" value="<%= customerLocation %>">
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label
							<% if (retrievalStatus !== "NOT_AVAILABLE") { %>class="text-muted"<% } %>
							for="retrievalStatusNAReason"><% if (retrievalStatus === "NOT_AVAILABLE") { %>* <% } %>Not Available Reason:</label>
						<br>
						<select
							<% if (retrievalStatus !== "NOT_AVAILABLE") { %>disabled<% } %>
							class="form-control chosen-select" name="retrievalStatusNAReason" id="retrievalStatusNAReason"><option value=""></option>
							<% _.forEach(retrievalStatusNAReasonList, function(option){ %>
								<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
							<% }); %>
						</select>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<% if (providerGroupNumber && providerGroupName) { %>
							<label class="control-label" for="providerGroupNumber">
								<abbr data-toggle="tooltip" title="<%= providerGroupName %>">Provider Group:</abbr>
							</label>
						<% } else { %>
							<label class="control-label" for="providerGroupNumber">Provider Group:</label>
						<% } %>
						<div class="form-group">
							<input id="providerGroupNumber" name="providerGroupNumber" autocomplete="off" class="form-control" value="<%= providerGroupNumber %>">
						</div>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="customerRefNumber">Customer Reference Number:</label>
						<input id="customerRefNumber" name="customerRefNumber" autocomplete="off" class="form-control" value="<%= customerRefNumber %>">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="reviewers">Reviewers:</label>
						<select multiple id="reviewers" name="reviewers" class="form-control chosen-select">
							<% _.forEach(reviewersList, function(user){ %>
								<option value="<%= user.id %>"
									<% if (user.checked) { %> selected <% } %>
								>
									<%= user.firstName %> <%= user.lastName %> (<%= user.openChartsAssigned %>)
								</option>
							<% }); %>
						</select>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="control-label" for="reviewers">Chart Attributes:</label>
						<select multiple id="chartAttributes" name="chartAttributes" class="form-control chosen-select">
							<% _.forEach(chartAttributeList, function(option){ %>
								<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
							<% }); %>
						</select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="userField1">User Field 1:</label>
						<input id="userField1" name="userField1" autocomplete="off" class="form-control" value="<%= userField1 %>" maxlength="4000">
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="userField2">User Field 2:</label>
						<input id="userField2" name="userField2" autocomplete="off" class="form-control" value="<%= userField2 %>" maxlength="4000">
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="userField3">User Field 3:</label>
						<input id="userField3" name="userField3" autocomplete="off" class="form-control" value="<%= userField3 %>" maxlength="4000">
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="control-label" for="statusValue">* Chart Status:</label>
						<select class="form-control chosen-select" id="statusValue" name="statusValue">
							<% _.forEach(statusList, function(option){ %>
								<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
							<% }); %>
						</select>
					</div>
				</div>
			</div>
			<div class="row form-buttons">
				<div class="col-sm-6"></div>
				<div class="col-sm-6 text-right">
					<button type="reset" class="btn btn-link">Undo Changes</button>
					<button type="submit" class="btn btn-emphasized">Save</button>
				</div>
			</div>
		`,
    chart_edit_chart_notes: `
			<ul class="list-group">
				<li class="list-group-item">
					<div id="add-note" class="input-group">
						<input autocomplete="off" class="form-control" placeholder="Add a note...">
						<span class="input-group-btn">
							<button class="btn btn-default" type="button" aria-label="Add Diag to List"><i class="fa fa-fw fa-lg fa-plus"></i></button>
						</span>
					</div>
				</li>
				<% _.forEach(notes, function(note){ %>
					<li class="list-group-item">
						<span class="badge" title="Author"><%= note.author.firstName %>&nbsp;<%= note.author.lastName %></span>
						<p><abbr class="small" data-toggle="tooltip" data-placement="bottom" data-container="body" title="<%= RVC.Utils.dateFormatter(note.timestamp," LLLL ") %>" data-utime="<%= note.timestamp %>"><em><%= RVC.Utils.relativeDateFormatter(note.timestamp) %></em></abbr></p>
						<div>
							<%= note.note %>
						</div>
					</li>
					<% }); %>
			</ul>
		`,
    chart_drg_list:
      '<div class="chart-review-meta"><!-- meta goes here --></div><div class="drg-list card"><!-- report goes here --></div>',
    chart_edit_drg_layout:
      '<div class="chart-review-meta"><!-- meta goes here --></div><div class="drg-list"><!-- drg details go here --></div>',
    chart_edit_drg_add:
      '<div class="chart-review-meta"><!-- meta goes here --></div><div class="drg-add-form card"><!-- add form goes here --></div>',
    chart_edit_drg_add_layout:
      '<input type="hidden" name="actionApproveSubmission" value="<%= actionApproveSubmission %>"><input type="hidden" name="actionStartEvaluation" value="<%= actionStartEvaluation %>"><input type="hidden" name="mappedHCCs" value="<%= mappedHCCs %>"><table class="table table-striped table-hover table-bordered"><thead><tr><th>DOS From</th><th>DOS Through</th><th>Diagnosis Code</th><th>Mapped HCCs</th><th>Client Claim ID</th><th>Client Claim Commercial Plan Id</th><th>Action</th><th>Note</th><th></th></tr></thead><tbody></tbody><tfoot><tr><td><input required class="form-control" id="fromDateOfService" name="fromDateOfService" placeholder="mm/dd/yyyy" value="<% if (fromDateOfService) { %><%= fromDateOfService %><% } %>" <% if (diagMinDate) { %> data-min="<%= diagMinDate %>"<% } %><% if (diagMaxDate) { %> data-max="<%= diagMaxDate %>"<% } %>></td><td><input required class="form-control" id="throughDateOfService" name="throughDateOfService" placeholder="mm/dd/yyyy" value="<% if (throughDateOfService) { %><%= throughDateOfService %><% } %>" <% if (diagMinDate) { %> data-min="<%= diagMinDate %>"<% } %><% if (diagMaxDate) { %> data-max="<%= diagMaxDate %>"<% } %>></td><td><input <% if (!canEditDiagCode) { %> disabled<% } %> required autocomplete="off" class="form-control" id="diagCode" name="diagCode" placeholder="Search" value="<% if (diagCode) { %><%= diagCode %><% } %>"></td><td><%= mappedHCCs %></td><td><input <% if (!canEditClaimNumber) { %> disabled<% } %> class="form-control" id="claimNumber" name="claimNumber" autocomplete="off"<% if (claimNumber) { %> value="<%= claimNumber %>"<% } %>></td><td><input <% if (!canEditCommercialPlanId) { %> disabled<% } %> class="form-control" id="commercialPlanId" name="commercialPlanId" autocomplete="off"<% if (commercialPlanId) { %> value="<%= commercialPlanId %>"<% } %>></td><td class="form-group"><select class="form-control chosen-select" data-placeholder="..." <% if (!canEditActions) { %> disabled <% } %> id="action" name="action"><option value=""></option><option <% if (!canApproveForSubmission) { %> disabled <% } %> value="actionApproveSubmission" <% if (actionApproveSubmission) { %> selected <% } %>>Approve for Submission</option><option <% if (!canStartEvaluation) { %> disabled <% } %> value="actionStartEvaluation" <% if (actionStartEvaluation) { %> selected <% } %>>Start Evaluation</option></select></td><td><input <% if (!canEditNote) { %> disabled<% } %> class="form-control" id="note" name="note" autocomplete="off"<% if (note) { %> value="<%= note %>"<% } %>></td><td class="text-center"><button <% if (!valid) { %> disabled <% } %> title="Add Diag" type="submit" class="btn btn-standard"><i class="fa fa-fw fa-lg fa-plus" aria-hidden="true"></i></button></td></tr></tfoot></table><div class="text-<% if (valid) { %>success<% } else { %>info<% } %>"><i class="fa fa-fw fa-lg fa-<% if (valid) { %>check<% } else { %>info-circle<% } %>"></i>&nbsp;<% if (valid) { %> This Diag is ready to be added to your list<% } else { %><%= statusMessage %><% } %></div><hr><div class="row"><div class="col-xs-6"><button class="btn btn-standard tab-switch" data-toggle="#tab-drg-list">Return to List of Diags</button><button class="hidden btn btn-standard tab-switch return-to-chart" data-toggle="#tab-chart-edit">Return to Chart</button></div><div class="col-xs-6 text-right"><button <% if (!canSubmitCollection) { %> disabled <% } %> type="button" aria-label="Save Valid Diags" class="btn btn-emphasized save-valid-drgs">Save Valid Diags</button></div></div>',
    chart_edit_drg_add_simple_layout: `
			<input type="hidden" name="mappedHCCs">
			<table class="table table-striped table-hover table-bordered">
				<thead>
					<tr>
						<th>DOS From</th>
						<th>DOS Through</th>
						<th>Diagnosis Code</th>
						<th>Mapped HCCs</th>
						<th>Client Claim ID</th>
						<th>Client Claim Commercial Plan Id</th>
						<th>Action</th>
						<th>Note</th>
						<th>Diag Attributes</th>
						<th></th>
					</tr>
				</thead>
				<tbody></tbody>
				<tfoot>
					<tr>
						<td>
							<input required autocomplete="off" class="form-control" id="fromDateOfService" name="fromDateOfService" placeholder="mm/dd/yyyy"
								<% if (diagMinDate) { %> data-min="<%= diagMinDate %>"<% } %>
								<% if (diagMaxDate) { %> data-max="<%= diagMaxDate %>"<% } %>
							>
						</td>
						<td>
							<input required autocomplete="off" class="form-control" id="throughDateOfService" name="throughDateOfService" placeholder="mm/dd/yyyy"
								<% if (diagMinDate) { %> data-min="<%= diagMinDate %>"<% } %>
								<% if (diagMaxDate) { %> data-max="<%= diagMaxDate %>"<% } %>
							>
						</td>
						<td>
							<input required disabled autocomplete="off" class="form-control" id="diagCode" name="diagCode" placeholder="Search">
						</td>
						<td class="mapped-hccs"></td>
						<td>
							<input class="form-control" id="claimNumber" name="claimNumber" autocomplete="off">
						</td>
						<td>
							<input disabled class="form-control" id="commercialPlanId" name="commercialPlanId" autocomplete="off">
						</td>
						<td class="form-group">
							<select disabled class="form-control" id="action" name="action">
								<option value="">...</option>
								<option disabled class="canApproveForSubmission" value="actionApproveSubmission">Approve for Submission</option>
								<option disabled class="canStartEvaluation" value="actionStartEvaluation">Start Evaluation</option>
							</select>
						</td>
						<td>
							<input disabled class="form-control" id="note" name="note" autocomplete="off">
						</td>
						<td class="form-group">
							<select multiple class="form-control chosen-select" id="diagnosisAttributes" name="diagnosisAttributes">
								<% _.forEach(diagnosisAttributesList, function(attr) { %>
									<option value="<%= attr.key %>">
										<%= attr.value %>
									</option>
								<% }); %>
							</select>
						</td>
						<td class="text-center">
							<button disabled title="Add Diag" type="submit" class="add-drg btn btn-standard"><i class="fa fa-fw fa-lg fa-plus" aria-hidden="true"></i></button>
						</td>
					</tr>
				</tfoot>
			</table>
			<div class="status-message">
				<span class="<% if (valid) { %>text-success<% } else { %>text-info<% } %>">
					<i class="fa fa-fw fa-lg <% if (valid) { %>fa-check<% } else { %>fa-info-circle<% } %>"></i>
					<% if (valid) { %>
						This Diag is ready to be added to your list
					<% } else { %>
						<%= statusMessage %>
					<% } %>
				</span>
			</div>
			<hr>
			<div class="row">
				<div class="col-xs-6">
					<button class="btn btn-standard tab-switch" data-toggle="#tab-drg-list">Return to List of Diags</button>
					<button class="hidden btn btn-standard tab-switch return-to-chart" data-toggle="#tab-chart-edit">Return to Chart</button>
				</div>
				<div class="col-xs-6 text-right">
					<button disabled type="button" aria-label="Save Valid Diags" class="btn btn-emphasized save-valid-drgs">Save Valid Diags</button>
				</div>
			</div>
		`,
    chart_edit_drg_add_diag: `
			<td <% if (errors) { %> class="bg-warning"<% } %>>
				<%= fromDateOfService %>
			</td>
			<td <% if (errors) { %> class="bg-warning"<% } %>>
				<%= throughDateOfService %>
			</td>
			<td <% if (errors) { %> class="bg-warning"<% } %>>
				<%= diagCode %>
			</td>
			<td <% if (errors) { %> class="bg-warning"<% } %>>
				<%= mappedHCCs %>
			</td>
			<td <% if (errors) { %> class="bg-warning"<% } %>>
				<%= claimNumber %>
			</td>
			<td <% if (errors) { %> class="bg-warning"<% } %>>
				<%= commercialPlanId %>
			</td>
			<td class="<% if (errors) { %>bg-warning<% } %>">
				<% if (actionApproveSubmission) { %>Approve for Submission<% } %>
				<% if (actionStartEvaluation) { %>Start Evaluation<% } %>
			</td>
			<td <% if (errors) { %> class="bg-warning"<% } %>>
				<%= note %>
			</td>
			<td>
				<%= diagnosisAttributesDisplay %>
			</td>
			<td class="text-center<% if (errors) { %> bg-warning<% } %>">
				<% if (errors) { %>
					<button title="Diag Issues" type="button" aria-label="View Diag Issues" class="btn btn-link" data-toggle="popover"
						data-content="<% _.forEach(errors, function(error){ %><p><%= RVC.Utils.htmlEscape(error) %></p><% }) %>"
					>
						<i class="fa fa-fw fa-lg fa-exclamation-triangle" aria-hidden="true"></i>
					</button>
				<% } %>
				<button title="Remove Diag" type="button" aria-label="Remove Diag from List" class="btn btn-link remove-drg" data-key="<%= id %>">
					<i class="fa fa-fw fa-lg fa-trash-o" aria-hidden="true"></i>
				</button>
			</td>
		`,
    chart_edit_drg_adds_edit_diag: `
			<fieldset>
				<div class="row">
					<% if (!_canEdit && !_canVoid) { %>
					<div class="col-sm-12">
						<div class="alert alert-warning" role="alert">
							<i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;
							<strong>Attention:</strong> This Diag Review Group can no longer be edited.</div>
					</div>
					<% } %>
					<div class="col-sm-6">
						<div class="form-group card">
							<div class="card-header">Diag Review Group</div>
							<div class="card-body form-horizontal">
								<div class="form-group">
									<label class="col-sm-4 control-label">Diag Code</label>
									<div class="col-sm-8">
										<p class="form-control-static"><%= diagnosisCode.code %> - <%= diagnosisCode.description %></p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Code Type</label>
									<div class="col-sm-8">
										<p class="form-control-static"><%= diagnosisCode.codeType %></p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Mapped HCCs</label>
									<div class="col-sm-8">
										<p class="form-control-static"><%= mappedHCCs %></p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">DOS</label>
									<div class="col-sm-8">
										<p class="form-control-static"><%= fromDateOfService %> - <%= throughDateOfService %></p>
									</div>
								</div>
								<hr>
								<div class="form-group">
									<label class="col-sm-4 control-label">Disposition</label>
									<div class="col-sm-8">
										<select class="form-control chosen-select" name="disposition" id="disposition"
											<% if (!_canEdit && !canEditDisposition) { %> disabled<% } %>
										><% _.forEach(dispositions, function(attr) { %>
											<option value="<%= attr.key %>" <% if (attr.checked) { %> selected<% } %>>
													<%= attr.value %>
											</option>
										<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Aux Type</label>
									<div class="col-sm-8">
										<select class="form-control chosen-select" name="auxType" id="auxType"
											<% if (!_canEdit) { %> disabled<% } %> >
											<option value=""></option>
											<% _.forEach(auxTypes, function(attr) { %>
												<option value="<%= attr.key %>" <% if (attr.checked) { %> selected<% } %>>
													<%= attr.key %> - <%= attr.value %>
												</option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Place of Service</label>
									<div class="col-sm-8">
										<select class="form-control chosen-select" name="placeOfServiceCode" id="placeOfServiceCode"
											<% if (!_canEdit) { %> disabled<% } %> >
											<option value=""></option>
											<% _.forEach(placesOfService, function(attr) { %>
												<option value="<%= attr.key %>" <% if (attr.checked) { %> selected<% } %>>
													<%= attr.value %>
												</option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Supplemental Reason</label>
									<div class="col-sm-8">
										<select class="form-control chosen-select" name="supplementalReasonCode" id="supplementalReasonCode"
											<% if (!_canEdit) { %> disabled<% } %> >
											<option value=""></option>
											<% _.forEach(supplementalReasonCodes, function(attr) { %>
												<option value="<%= attr.key %>" <% if (attr.checked) { %> selected<% } %>>
													<%= attr.key %> - <%= attr.value %>
												</option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Source Reference Number</label>
									<div class="col-sm-8">
										<input class="form-control" id="sourceReferenceNumber" name="sourceReferenceNumber" autocomplete="off"
											<% if (!_canEdit) { %> disabled<% } %>
											value="<%= sourceReferenceNumber %>"
										>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Provider Reference Number</label>
									<div class="col-sm-8">
										<input class="form-control" id="providerReferenceNumber" name="providerReferenceNumber" autocomplete="off"
											<% if (!_canEdit) { %> disabled<% } %>
											value="<%= providerReferenceNumber %>"
										>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Assessment Id</label>
									<div class="col-sm-8">
										<input class="form-control" id="assessmentId" name="assessmentId" autocomplete="off"
											<% if (!_canEdit) { %> disabled<% } %>
											value="<%= assessmentId %>"
										>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Rendering Provider Name</label>
									<div class="col-sm-8">
										<input class="form-control" id="diagRenderingProviderName" name="diagRenderingProviderName" autocomplete="off"
											<% if (!_canEdit) { %> disabled<% } %>
											value="<%= diagRenderingProviderName %>"
										>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Rendering Provider NPI</label>
									<div class="col-sm-8">
										<input class="form-control" id="diagRenderingProviderNpi" name="diagRenderingProviderNpi" autocomplete="off"
											<% if (!_canEdit) { %> disabled<% } %>
											value="<%= diagRenderingProviderNpi %>"
										>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Diag Attributes</label>
									<div class="col-sm-8">
										<select multiple id="diagnosisAttributes" name="diagnosisAttributes" class="form-control chosen-select"
											<% if (!_canEdit || !canEditDiagnosisAttributes) { %> disabled<% } %>
										>
											<% _.forEach(diagnosisAttributesList, function(attr) { %>
												<option <% if (!attr.enabled) { %> disabled<% } %>
													value="<%= attr.key %>"
													<% if (attr.checked) { %> selected<% } %>
												>
													<%= attr.value %>
												</option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Diag Notes</label>
									<div class="col-sm-8">
										<div class="panel panel-default rvc-panel">
											<ul class="list-group">
												<% if (_canEdit || _canVoid) { %>
													<li class="list-group-item">
														<div id="add-note" class="input-group">
															<input class="form-control" autocomplete="off" placeholder="Add a note...">
															<span class="input-group-btn">
																<button class="btn btn-default" type="button" aria-label="Save Note">
																	<i class="fa fa-fw fa-lg fa-plus"></i>
																</button>
															</span>
														</div>
													</li>
												<% } %>
												<% _.forEach(notesList, function(note){ %>
													<li class="list-group-item">
														<span class="badge" title="Author">
															<%= note.author.firstName %>&nbsp;
																<%= note.author.lastName %>
														</span>
														<p>
															<abbr class="small" data-toggle="tooltip" data-placement="bottom" data-container="body"
																title="<%= RVC.Utils.dateFormatter(note.timestamp,'LLLL') %>"
																data-utime="<%= note.timestamp %>"
															>
																<em><%= RVC.Utils.relativeDateFormatter(note.timestamp) %></em>
															</abbr>
														</p>
														<div>
															<%= note.note %>
														</div>
													</li>
												<% }); %>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group card">
							<div class="card-header">Last Saved</div>
							<div class="card-body form-horizontal">
								<div class="form-group">
									<label class="col-sm-4 control-label">Disposition</label>
									<div class="col-sm-8">
										<p class="form-control-static">
											<%= dispositionLabel %>
										</p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Diag Attributes</label>
									<div class="col-sm-8">
										<p class="form-control-static">
											<a href="#" data-toggle="popover" data-content="<ul><% _.forEach(diagnosisAttributesLabels.tooltip, function(item) { %><li><strong><%= RVC.Utils.htmlEscape(item.key) %></strong>: <%= RVC.Utils.htmlEscape(item.value) %></li><% }) %></ul>">
												<%= diagnosisAttributesLabels.value %>
											</a>
										</p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Claim Number</label>
									<div class="col-sm-8">
										<p class="form-control-static">
											<%= auditClaimNbr %>
										</p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Claim Commercial Plan Id</label>
									<div class="col-sm-8">
										<p class="form-control-static">
											<%= auditCommercialPlanId %>
										</p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Status</label>
									<div class="col-sm-8">
										<p class="form-control-static">
											<%= statusLabel %>
										</p>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Reason</label>
									<div class="col-sm-8">
										<p class="form-control-static">
											<abbr href="#" data-toggle="popover" data-content="<ul><% _.forEach(statusReasons.tooltip, function(item) { %><li><strong><%= RVC.Utils.htmlEscape(item.key) %></strong>: <%= RVC.Utils.htmlEscape(item.value) %></li><% }) %></ul>">
												<%= statusReasons.value %>
											</abbr>
										</p>
									</div>
								</div>
							</div>
						</div>
						<div class="form-group card">
							<div class="card-header">Claim Selection</div>
							<div class="card-body form-horizontal">
								<div class="form-group">
									<label class="col-sm-4 control-label">Client Claim Number</label>
									<div class="col-sm-8">
										<input class="form-control" id="clientClaimNbr" name="clientClaimNbr" autocomplete="off"
											<% if (!_canEdit || !canEditClientClaimNbr) { %> disabled<% } %>
											value="<%= clientClaimNbr %>"
										>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">Client Claim Commercial Plan Id</label>
									<div class="col-sm-8">
										<input class="form-control" id="clientCommercialPlanId" name="clientCommercialPlanId" autocomplete="off"
											<% if (!_canEdit || !canEditClientCommercialPlanId) { %> disabled<% } %>
											value="<%= clientCommercialPlanId %>"
										>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">MatchPoint Claim Number</label>
									<div class="col-sm-8">
										<div class="input-group">
											<input readonly class="form-control" id="matchPointClaimNbr" name="matchPointClaimNbr" autocomplete="off"
												<% if (!_canEdit || !canEditMatchPointClaimNbr) { %> disabled<% } %>
												value="<%= matchPointClaimNbr %>"
											>
											<span class="input-group-btn">
												<button <% if (!matchPointClaimButtonEnabled) {%> disabled
													<% } %> id="matchPointClaimNbrChooser" class="btn btn-standard" type="button" aria-label="
														<%= matchPointClaimButtonLabel %>">
															<%= matchPointClaimButtonLabel %>
												</button>
											</span>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label class="col-sm-4 control-label">MatchPoint Claim Commercial Plan Id</label>
									<div class="col-sm-8">
										<input readonly class="form-control" id="matchPointCommercialPlanId" name="matchPointCommercialPlanId"
											<% if (!_canEdit) { %> disabled<% } %>
											value="<%= matchPointCommercialPlanId %>"
										>
									</div>
								</div>
								<fieldset>
									<legend>Options</legend>
									<div class="form-group">
										<label class="col-sm-4 control-label">Claim Selection</label>
										<div class="col-sm-8">
											<select class="form-control chosen-select" name="claimSelection" id="claimSelection"
												<% if (!_canEdit) { %> disabled<% } %>
											>
												<option value=""></option>
												<% _.forEach(claimSelections, function(attr) { %>
													<option <% if (!attr.enabled) { %> disabled<% } %>
														value="<%= attr.key %>"
														<% if (attr.checked) { %> selected<% } %>
													>
														<%= attr.value %>
													</option>
												<% }); %>
											</select>
										</div>
									</div>
									<div class="form-group">
										<label class="col-sm-4 control-label">Action</label>
										<div class="col-sm-8">
											<select class="form-control chosen-select" name="evaluationAction" id="evaluationAction"
												<% if (!_canEdit) { %> disabled<% } %>
											>
												<option value=""></option>
												<% _.forEach(evaluationActions, function(attr) { %>
													<option <% if (!attr.enabled) { %> disabled<% } %>
														value="<%= attr.key %>"
														<% if (attr.checked) { %> selected<% } %>
													>
														<%= attr.value %>
													</option>
												<% }); %>
											</select>
										</div>
									</div>
								</fieldset>
							</div>
						</div>
							</div>
				</div>
				<div class="row">
					<div class="col-sm-6"></div>
					<div class="col-sm-6 text-right">
						<% if (_canEdit || _canVoid) { %>
							<button type="button" class="btn btn-link undo">Undo Changes</button>
							<button type="button" class="btn btn-standard submit"><i class="fa fa-fw fa-floppy-o" aria-hidden="true"></i>&nbsp;Save &amp; Close</button>
						<% } %>
					</div>
				</div>
			</fieldset>
		`,
    chart_edit_drg_deletes_edit_diag: `
			<fieldset>
				<% if (!_canEdit && !_canVoid) { %>
				<div class="row">
					<div class="col-sm-12">
						<div class="alert alert-warning" role="alert"><i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;<strong>Attention:</strong> This Diag Review Group cannot be edited.</div>
					</div>
				</div>
				<% } %>
				<div class="row">
					<div class="col-sm-6">
						<div class="form-group card">
							<div class="card-header">Diag Review Group</div>
							<div class="card-body form-horizontal">
								<div class="form-group"><label class="col-sm-4 control-label">Project</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= projectName %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Diag Code</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= diagnosisCode.code %> - <%= diagnosisCode.description %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Code Type</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= diagnosisCode.codeType %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Mapped HCCs</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= mappedHCCs %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">DOS</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= fromDateOfService %> - <%= throughDateOfService %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Claim Number</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= claimNbr %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Claim Commercial Plan ID</label>
									<div class="col-sm-8">
										<input <% if (!_canEdit || !canEditClaimCommercialPlanId) { %> disabled <% } %> class="form-control" id="claimCommercialPlanId" name="claimCommercialPlanId" autocomplete="off" value="<%= claimCommercialPlanId %>">
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Provider</label>
									<div class="col-sm-8">
										<p class="form-control-static">
											<strong><%= providerNumber %></strong><br>
											<% if (providerFirstName) { %> <%= providerFirstName %>&nbsp; <% } %>
											<%= providerLastName %>
										</p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Disposition</label>
									<div class="col-sm-8">
										<select <% if (!_canEdit && !canEditDisposition) { %> disabled <% } %> class="form-control chosen-select" name="disposition" id="disposition"><% _.forEach(dispositions, function(attr) { %>
											<option value="<%= attr.key %>" <% if (attr.checked) { %> selected <% } %>><%= attr.value %></option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Aux Type</label>
									<div class="col-sm-8">
										<select <% if (!_canEdit) { %> disabled <% } %> class="form-control chosen-select" name="auxType" id="auxType">
											<option value=""></option><% _.forEach(auxTypes, function(attr) { %>
											<option value="<%= attr.key %>" <% if (attr.checked) { %> selected <% } %>><%= attr.key %> - <%= attr.value %></option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Place of Service</label>
									<div class="col-sm-8">
										<select <% if (!_canEdit) { %> disabled <% } %> class="form-control chosen-select" name="placeOfServiceCode" id="placeOfServiceCode">
											<option value=""></option><% _.forEach(placesOfService, function(attr) { %>
											<option value="<%= attr.key %>" <% if (attr.checked) { %> selected <% } %>><%= attr.value %></option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Supplemental Reason</label>
									<div class="col-sm-8">
										<select <% if (!_canEdit) { %> disabled <% } %> class="form-control chosen-select" name="supplementalReasonCode" id="supplementalReasonCode">
											<option value=""></option><% _.forEach(supplementalReasonCodes, function(attr) { %>
											<option value="<%= attr.key %>" <% if (attr.checked) { %> selected <% } %>><%= attr.key %> - <%= attr.value %></option>
											<% }); %>
										</select>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Customer Reference Number</label>
									<div class="col-sm-8">
										<input <% if (!_canEdit) { %> disabled <% } %> class="form-control" id="customerReferenceNumber" name="customerReferenceNumber" autocomplete="off" value="<%= customerReferenceNumber %>">
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Source Reference Number</label>
									<div class="col-sm-8">
										<input <% if (!_canEdit) { %> disabled <% } %> class="form-control" id="sourceReferenceNumber" name="sourceReferenceNumber" autocomplete="off" value="<%= sourceReferenceNumber %>">
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Provider Reference Number</label>
									<div class="col-sm-8">
										<input <% if (!_canEdit) { %> disabled <% } %> class="form-control" id="providerReferenceNumber" name="providerReferenceNumber" autocomplete="off" value="<%= providerReferenceNumber %>">
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Assessment ID</label>
									<div class="col-sm-8">
										<input <% if (!_canEdit) { %> disabled <% } %> class="form-control" id="assessmentId" name="assessmentId" autocomplete="off" value="<%= assessmentId %>">
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Rendering Provider Name</label>
									<div class="col-sm-8">
										<input <% if (!_canEdit) { %> disabled <% } %> class="form-control" id="diagRenderingProviderName" name="diagRenderingProviderName" autocomplete="off" value="<%= diagRenderingProviderName %>">
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Rendering Provider NPI</label>
									<div class="col-sm-8">
										<input <% if (!_canEdit) { %> disabled <% } %> class="form-control" id="diagRenderingProviderNpi" name="diagRenderingProviderNpi" autocomplete="off" value="<%= diagRenderingProviderNpi %>">
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Diag Notes</label>
									<div class="col-sm-8">
										<div class="panel panel-default rvc-panel">
											<ul class="list-group">
												<li class="list-group-item">
													<div id="add-note" class="input-group">
														<input class="form-control" autocomplete="off" placeholder="Add a note..."><span class="input-group-btn"><button class="btn btn-default" type="button" aria-label="Save Note"><i class="fa fa-fw fa-lg fa-plus"></i></button></span>
													</div>
												</li><% _.forEach(notesList, function(note){ %>
												<li class="list-group-item"><span class="badge" title="Author">
													<%= note.author.firstName %>&nbsp;<%= note.author.lastName %></span>
													<p>
														<abbr class="small" data-toggle="tooltip" data-placement="bottom" data-container="body" title="<%= RVC.Utils.dateFormatter(note.timestamp," LLLL ") %>" data-utime="<%= note.timestamp %>"><em><%= RVC.Utils.relativeDateFormatter(note.timestamp) %></em></abbr>
													</p>
													<div> <%= note.note %> </div>
												</li> <% }); %>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group card">
							<div class="card-header">Last Saved</div>
							<div class="card-body form-horizontal">
								<div class="form-group"><label class="col-sm-4 control-label">Disposition</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= dispositionLabel %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Claim Commercial Plan ID</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= auditCommercialPlanId %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Status</label>
									<div class="col-sm-8">
										<p class="form-control-static"> <%= statusLabel %> </p>
									</div>
								</div>
								<div class="form-group"><label class="col-sm-4 control-label">Reason</label>
									<div class="col-sm-8">
										<p class="form-control-static"><abbr href="#" data-toggle="popover" data-content="<ul><% _.forEach(statusReasons.tooltip, function(item) { %><li><strong><%= RVC.Utils.htmlEscape(item.key) %></strong>: <%= RVC.Utils.htmlEscape(item.value) %></li><% }) %></ul>"> <%= statusReasons.value %> </abbr></p>
									</div>
								</div>
							</div>
						</div>
						<div class="form-group card">
							<div class="card-header">Action</div>
							<div class="card-body form-horizontal">
								<div class="form-group">
									<label class="col-sm-4 control-label">Action</label>
									<div class="col-sm-8">
										<select <% if (!_canEdit) { %> disabled <% } %> class="form-control chosen-select" name="action" id="action">
											<option value=""></option><% _.forEach(actions, function(attr) { %>
											<option <% if (!attr.enabled) { %> disabled <% } %> value="<%= attr.key %>" <% if (attr.checked) { %> selected <% } %>><%= attr.value %></option>
											<% }); %>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6"></div>
					<div class="col-sm-6 text-right">
						<% if (_canEdit || _canVoid) { %>
						<button type="button" aria-label="Undo Changes" class="btn btn-link undo">Undo Changes</button>&nbsp;
						<button type="button" aria-label="Save and Close" class="btn btn-standard submit"><i class="fa fa-fw fa-floppy-o" aria-hidden="true"></i>&nbsp;Save &amp; Close</button>
						<% } %>
					</div>
				</div>
			</fieldset>
		`,
    chart_edit_drg_edit_matchpoint_claim_matches_meta:
      '<div class="row"><div class="col-sm-6"><h4>Diag Code: <strong><%= diagnosisCode %></strong><br><small>DOS: <%= RVC.Utils.dateFormatter(fromDos) %> - <%= RVC.Utils.dateFormatter(throughDos) %></small></h4></div><div class="col-sm-6"><h4 class="pull-right">Run Id: <strong><%= cmRunSid %></strong><br><small>Run Date: <%= RVC.Utils.dateFormatter(cmRunDate) %></small></h4></div></div><hr><div class="row card-group"><div class="col-sm-4"><div class="form-group card"><div class="card-header">Member</div><div class="card-body"><p># <%= memberNumber %></p><p><strong><%= memberName %></strong></p><p><strong>DOB:</strong>&nbsp;<%= RVC.Utils.dateFormatter(memberDob) %></p><p><strong>Eligible Issuers on DOS:</strong>&nbsp;<%= eligIssuersOnDos %></p></div></div></div><div class="col-sm-4"><div class="form-group card"><div class="card-header">Provider</div><div class="card-body"><p># <%= providerNbr %></p><p><strong><%= providerName %></strong></p><p><strong>EIN:</strong>&nbsp;<%= providerEin %><br><strong>NPI:</strong>&nbsp;<%= providerNpid %> </p></div></div></div><div class="col-sm-4"><div class="form-group card"><div class="card-header">Revenue Info</div><div class="card-body"><p><strong>HCC:</strong>&nbsp;<%= hccCode %><br><%= hccDescription %></p><p><strong>Group Severity:</strong>&nbsp;<% if (!_.isEmpty(groupCode)) { %><%= groupCode %><br><%= groupDescription %><% } else { %>N/A<% } %></p></div></div></div></div>',
    chart_edit_drg_edit_matchpoint_params_meta:
      '<div class="row"><div class="col-sm-12"><h4><%= description %><br><small>ID: <%= sid %></small><br><small>Created: <%= RVC.Utils.unixTimestampFormatter(createDate) %></small><br><small>Requested By: <%= requestedBy %></small></h4></div></div><hr>',
    chart_edit_drg_deletes_edit_meta:
      '<div class="row"><div class="col-sm-12 meta-project-name"><!-- project name --></div></div><div class="row card-group"><div class="col-sm-4 meta-member"></div><div class="col-sm-4 meta-eligibility"></div><div class="col-sm-4 meta-categories"></div></div>',
    chart_bulk_edit_form: `
			<!--
			<div class="row">
				<div class="col-xs-12">
					<p class="lead text-muted">
						Instructions sed porttitor lectus nibh. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Lorem ipsum dolor sit amet, consectetur
						adipiscing elit.
					</p>
				</div>
			</div>
			-->
			<div class="row card-group">
				<div class="col-xs-12">
					<div class="card">
						<div class="card-header">Editable Fields</div>
						<div class="card-body">
							<div class="row">
								<div class="col-xs-12 form-group">
									<label for="chartStatus">Chart Status:</label>
									<br>
									<select class="form-control chosen-select" name="chartStatus" id="chartStatus"><option value=""></option>
										<% _.forEach(statusList, function(option){ %>
											<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
										<% }); %>
									</select>
								</div>
								<div class="col-xs-12 form-group">
									<label for="projectId">Project:</label>
									<br>
									<select class="form-control chosen-select" name="projectId" id="projectId"><option value=""></option>
										<% _.forEach(projectIdList, function(option){ %>
											<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
										<% }); %>
									</select>
								</div>
								<div class="col-xs-12 form-group">
									<label for="retrievalStatus">Retrieval Status:</label>
									<br>
									<select class="form-control chosen-select" name="retrievalStatus" id="retrievalStatus"><option value=""></option>
										<% _.forEach(retrievalStatusList, function(option){ %>
											<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
										<% }); %>
									</select>
								</div>
								<% if (retrievalStatus === "NOT_AVAILABLE") { %>
									<div class="col-xs-12 form-group">
										<label for="retrievalStatusNAReason">* Not Available Reason:</label>
										<br>
										<select class="form-control chosen-select" name="retrievalStatusNAReason" id="retrievalStatusNAReason"><option value=""></option>
											<% _.forEach(retrievalStatusNAReasonList, function(option){ %>
												<option value="<%= option.key %>" <% if (option.checked) { %> selected <% } %>><%= option.value %></option>
											<% }); %>
										</select>
									</div>
								<% } %>
								<div class="col-xs-12 form-group">
									<label for="reviewers">Reviewers:</label>
									<br>
									<select multiple class="form-control chosen-select" name="reviewers" id="reviewers">
										<% _.forEach(reviewersList, function(user){ %>
											<option value="<%= user.id %>"
												<% if (user.checked) { %> selected <% } %>
											>
												<%= user.firstName %> <%= user.lastName %> (<%= user.openChartsAssigned %>)
											</option>
										<% }); %>
									</select>
									<div class="checkbox">
										<label class="text-muted">
											<input disabled type="checkbox" name="keepExistingReviewers" id="keepExistingReviewers">Keep Existing Reviewers
										</label>
									</div>
								</div>
							</div>
						</div>
						<div class="card-footer">
							<div class="row">
								<div class="col-xs-12 text-right">
									<button type="reset" class="btn btn-link">Undo Changes</button>
									<button type="submit" class="btn btn-emphasized">Save</button>

									<button disabled type="button" class="hidden btn btn-standard">
										<i class="fa fa-fw fa-lg fa-spin fa-cog"></i>&nbsp;Saving...
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		`,
    chart_bulk_import_form: `
			<div class="card">
				<div class="row">
					<div class="col-sm-12">
						<h4>Step 1:</h4>
						<p class="lead text-muted">Select a type of import.</p>
					</div>
					<div class="col-sm-12">
						<div class="radio">
							<label>
								<input type="radio" name="type" value="create" checked>
								<span class="lead">Chart Creation</span>
								<span class="help-block">
									The file format is a 29 column <abbr title="comma-separated values">CSV</abbr>.
									Also knowns as a "Chart Start" format. Allows users to import a chase list thereby
									creating charts. Once successfully loaded, the content of the chase list will be
									apparent on Charts in Risk View and coding can begin. If requested, the content can
									be transferred from DA to to CRCR division.
									<br/>
									<a class="instructions" data-type="create" href="#create-instructions">Click here for instructions</a>.
								</span>
							</label>
						</div>
						<div class="radio">
							<label>
								<input type="radio" name="type" value="update">
								<span class="lead">Chart Update</span>
								<span class="help-block">
									The file format is a 31 column <abbr title="comma-separated values">CSV</abbr>.
									Allows users to modify information related to existing charts with known Review
									Numbers. The file can be used to change the chart status, retrieval status,
									address info, user defined fields & more for multiple chart review numbers
									within a single file. Generally, for users who are coding charts in the Risk
									View UI.
									<br/>
									<a class="instructions" data-type="update" href="#update-instructions">Click here for instructions</a>.
								</span>
							</label>
						</div>
					</div>
					<div class="col-sm-12">
						<hr/>
					</div>
					<div class="col-sm-12">
						<h4>Step 2:</h4>
						<p class="lead text-muted no-margin">Select your source file.</p>
						<div class="help-block">Your source file cannot have a header. Please remove the header before attempting to upload the file.</div>
						<label class="upload-file-selector btn btn-standard">
							<i class="fa fa-search"></i>&nbsp;Browse...
							<input type="file" style="display:none;">
						</label>
					</div>
					<div class="col-sm-12">
						<hr/>
					</div>
					<div class="col-sm-12">
						<h4>Step 3:</h4>
						<p class="lead text-muted">Upload <span class="upload-file-details">the file</span> for processing.</p>
						<button disabled type="submit" aria-label="Upload Selected File" class="btn btn-standard">
							<i class="fa fa-cloud-upload"></i>&nbsp;Upload
						</button>
					</div>
				</div>
			</div>
		`,
    chart_bulk_assign_form: `
			<!--
			<div class="row">
				<div class="col-xs-12">
					<p class="lead text-muted">
						Instructions sed porttitor lectus nibh. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Lorem ipsum dolor sit amet, consectetur
						adipiscing elit.
					</p>
				</div>
			</div>
			-->
			<div class="row card-group">
				<div class="col-xs-12">
					<div class="card">
						<div class="card-header">Assignments</div>
						<div class="card-body">
							<div class="row">
								<div class="col-xs-12 form-group">
									<label for="limitedTo">Limited To:</label>
									<br>
									<input required name="limitedTo" id="limitedTo" type="number" class="form-control"
										value="<%= limitedTo %>"
										min="1"
										max="<%= chartCount %>"
										step="1"
									>
								</div>
								<div class="col-xs-12 form-group">
									<label for="reviewers">Reviewers:</label>
									<br>
									<select multiple class="form-control chosen-select" name="reviewers" id="reviewers">
										<% _.forEach(reviewersList, function(user){ %>
											<option value="<%= user.id %>"
												<% if (user.checked) { %> selected <% } %>
											>
												<%= user.firstName %> <%= user.lastName %> (<%= user.openChartsAssigned %>)
											</option>
										<% }); %>
									</select>
								</div>
								<% if (reviewersCount) { %>
									<div class="col-xs-12 form-group assignments">
										<table class="table table-striped table-hover table-bordered table-condensed">
											<thead>
												<tr>
													<th class="name">Reviewer</th>
													<th class="count"># Charts</th>
												</tr>
											</thead>
											<tbody>
												<% _.forEach(reviewersList, function(user) { %>
													<% if (user.checked) { %>
														<tr>
															<td><%= user.firstName %> <%= user.lastName %></td>
															<td>
																<input required name="assignments[]" type="number" class="form-control"
																	value="<%= user.bulkAssignedChartCount %>"
																	min="0"
																	max="<%= limitedTo %>"
																	step="1"
																>
															</td>
														</tr>
													<% } %>
												<% }); %>
											</tbody>
											<!--tfoot>
												<tr>
													<th class="text-right">Total Assignments:</th>
													<td>0</td>
												</tr>
											</tfoot-->
										</table>
									</div>
									<div class="col-xs-12 form-group">
										<div class="checkbox">
											<label>
												<input type="checkbox" name="keepExistingReviewers" id="keepExistingReviewers"
													<% if (keepExistingReviewers) { %>checked<% } %>
												>Keep existing reviewers
											</label>
										</div>
									</div>
								<% } %>
							</div>
						</div>
						<% if (reviewersCount) { %>
							<div class="card-footer">
								<div class="row">
									<div class="col-xs-12 text-right">
										<button type="reset" class="btn btn-link">Undo Changes</button>
										<button type="submit" class="btn btn-emphasized">Save</button>

										<button disabled type="button" class="hidden btn btn-standard">
											<i class="fa fa-fw fa-lg fa-spin fa-cog"></i>&nbsp;Saving...
										</button>
									</div>
								</div>
							</div>
						<% } %>
					</div>
				</div>
			</div>
		`,
  },
};

export { templates as default };
